function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.122317 11.2365C1.47064 7.75983 2.39471 4.28072 3.64359 0.803722C3.72513 0.578296 3.12655 0.0984858 5.61571 0.0138662C8.20364 -0.0742134 10.8002 0.292395 11.471 0.534972C12.3427 0.849982 11.8542 1.25104 11.9377 1.57982C12.0504 2.02224 12.0153 2.44263 11.7468 2.88356C10.7226 4.56369 9.39353 6.24096 8.36737 7.92147C7.78668 8.87282 7.09861 9.82349 6.36081 10.7734C6.16393 11.0267 6.77511 11.7791 4.91702 11.9565C3.77221 12.0658 2.0036 11.95 1.12063 11.842C-0.332429 11.6641 -0.0029694 11.4595 0.122317 11.2365Z",
  fill: "#A9DBFB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.1223 11.2365C29.4706 7.75983 30.3947 4.28072 31.6436 0.803722C31.7251 0.578296 31.1265 0.0984858 33.6157 0.0138662C36.2036 -0.0742134 38.8002 0.292395 39.471 0.534972C40.3427 0.849982 39.8542 1.25104 39.9377 1.57982C40.0504 2.02224 40.0153 2.44263 39.7468 2.88356C38.7226 4.56369 37.3935 6.24096 36.3674 7.92147C35.7867 8.87282 35.0986 9.82349 34.3608 10.7734C34.1639 11.0267 34.7751 11.7791 32.917 11.9565C31.7722 12.0658 30.0036 11.95 29.1206 11.842C27.6676 11.6641 27.997 11.4595 28.1223 11.2365Z",
  fill: "#297DDC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.1223 11.2365C57.4706 7.75983 58.3947 4.28072 59.6436 0.803722C59.7251 0.578296 59.1265 0.0984858 61.6157 0.0138662C64.2036 -0.0742134 66.8002 0.292395 67.471 0.534972C68.3427 0.849982 67.8542 1.25104 67.9377 1.57982C68.0504 2.02224 68.0153 2.44263 67.7468 2.88356C66.7226 4.56369 65.3935 6.24096 64.3674 7.92147C63.7867 8.87282 63.0986 9.82349 62.3608 10.7734C62.1639 11.0267 62.7751 11.7791 60.917 11.9565C59.7722 12.0658 58.0036 11.95 57.1206 11.842C55.6676 11.6641 55.997 11.4595 56.1223 11.2365Z",
  fill: "#A9DBFB"
});

function SvgPattern({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 12,
    viewBox: "0 0 68 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.4a2fc83d72f30ae4f387a16acf9399ae.svg";
export { ForwardRef as ReactComponent };